import type { FastifyPluginAsync } from 'fastify'
import { authMiddleware } from '../../middleware/auth.middleware.js'
import { adminMiddleware } from './admin.middleware.js'
import { AdminRewardsController } from './admin.rewards.controller.js'

export const adminRewardsRoutes: FastifyPluginAsync = async (fastify) => {
  fastify.addHook('onRequest', authMiddleware)
  fastify.addHook('onRequest', adminMiddleware)

  const controller = new AdminRewardsController()

  fastify.get('/config', controller.getConfig.bind(controller))
  fastify.get('/rules', controller.getAllRules.bind(controller))
  fastify.get('/rules/:event', controller.getRule.bind(controller))
  fastify.patch('/rules/:event', controller.updateRule.bind(controller))
  fastify.post('/rules/batch', controller.batchUpdateRules.bind(controller))
  fastify.post('/reset', controller.resetConfig.bind(controller))
  fastify.get('/statistics', controller.getStatistics.bind(controller))
}
